import ServiceSectionShell from "./ServiceSectionShell";

const advisoryAreas = [
  {
    id: "01",
    title: "C-suite & board advisory",
    detail:
      "Vendor-independent counsel on IT strategy, budget, and board reporting for CEOs, CFOs, and boards of directors.",
    tag: "Strategy",
  },
  {
    id: "02",
    title: "IT strategy & roadmap",
    detail:
      "Three-year operating plans tied to clinical, financial, and growth priorities—with realistic sequencing and staffing.",
    tag: "Planning",
  },
  {
    id: "03",
    title: "Vendor, contract & spend review",
    detail:
      "Audit existing contracts, renegotiate MSAs, and rationalize overlapping software and managed services.",
    tag: "Cost",
  },
  {
    id: "04",
    title: "M&A and IT integration",
    detail:
      "Due diligence, Day-1 IT readiness, and post-close integration across EHR, infrastructure, and applications.",
    tag: "M&A",
  },
  {
    id: "05",
    title: "Interim & fractional leadership",
    detail:
      "Bench of former CIOs, CTOs, and CISOs available as interim or fractional operators through leadership transitions.",
    tag: "Leadership",
  },
];

export default function AdvisoryServices() {
  return (
    <ServiceSectionShell
      kicker="Advisory Services"
      title="Operator-led counsel for CIOs, CFOs, CEOs, and boards"
      lead="We advise health system leaders on vendor decisions, M&A, cost rationalization, and team structure—the way you'd expect from peers who've run the job, not consultants selling slideware."
      tone="white"
    >
      <ol className="relative space-y-4">
        {advisoryAreas.map((a) => (
          <li
            key={a.id}
            className="group relative flex flex-col gap-4 rounded-2xl border border-shark-200 bg-white p-5 transition-colors hover:border-complement-300 sm:flex-row sm:items-start sm:p-6"
          >
            <div className="flex items-center gap-4 sm:w-[200px] sm:flex-col sm:items-start sm:border-r sm:border-shark-200 sm:pr-6">
              <span className="text-[1.75rem] font-extrabold leading-none text-complement-600 sm:text-[2.25rem]">
                {a.id}
              </span>
              <span className="rounded-full border border-shark-200 bg-shark-50/60 px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-[0.12em] text-shark-500">
                {a.tag}
              </span>
            </div>

            <div className="flex-1">
              <h4 className="text-[1.05rem] font-bold leading-snug text-shark-900 transition-colors group-hover:text-complement-700">
                {a.title}
              </h4>
              <p className="mt-2 max-w-2xl text-[0.92rem] leading-relaxed text-shark-500">
                {a.detail}
              </p>
            </div>
          </li>
        ))}
      </ol>
    </ServiceSectionShell>
  );
}
